import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { func, bool } from "prop-types";
import { Modal, Button } from "shared/components";
import Loader from "../../../components/Loading";
import styles from "../styles.css";
import IconRepair from "../../../assets/svg/icone-reparo-modal.svg";
import { getProductDetail } from "../../../services/state/repair/action";

class ModalProductConfirm extends Component {
  state = {
    busy: false,
  };

  componentDidMount() {
    const { product } = this.props;
    !this.isOdin() && this.getProductDetail(product);
  }

  isOdin() {
    const { product } = this.props;
    return product.productSystem === "ODIN";
  }

  getProductDetail(product) {
    this.setState({ busy: true });
    this.props
      .getProductDetail(product)
      .then(() => this.setState({ busy: false }));
  }

  onConfirm = () => {
    this.props.onNextStep();
  };

  render() {
    const {
      t,
      isCurrentStep,
      onPreviousStep,
      onReset,
      product,
      detail,
      hasDetail,
    } = this.props;

    if (!product) return null;

    return (
      <Fragment>
        <Modal
          isOpen={isCurrentStep && (hasDetail || this.isOdin())}
          onClose={onReset}
          title={t("MSG_0194")}
          icon={IconRepair}
          ariaHideApp={false}
          noOverflow
        >
          <p className={styles.formInstructions}>{t("MSG_0213")}</p>

          <dl className={styles.productDescription}>
            <div>
              <dt>{product.productName ? t("MSG_0214") : null}</dt>
              <dd>{product.productName}</dd>
              {/* <dt>{detail.addressName ? t('MSG_0053') : null}</dt>
              <dd>{detail.addressName}</dd> */}
              <dt>{detail.city ? t("MSG_0054") : null}</dt>
              <dd>{detail.city}</dd>
            </div>

            <div>
              <dt>{product.circuit ? t("MSG_0100") : null}</dt>
              <dd>{product.circuit}</dd>
              {/* <dt>{detail.city ? t('MSG_0054') : null}</dt>
              <dd>{detail.city}</dd> */}
            </div>
          </dl>

          <div className={styles.incidentModalButtons}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>
            <Button onClick={this.onConfirm} relevance="normal" callToAction>
              {t("MSG_0215")}
            </Button>
          </div>
        </Modal>
        <Loader isOpen={this.state.busy} />
      </Fragment>
    );
  }
}

ModalProductConfirm.propTypes = {
  isOpen: bool,
  onReset: func.isRequired,
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
};

const mapStateToProps = ({ repair: { wizard } }) => ({
  hasDetail: !!wizard.detail,
  detail: wizard.detail || {},
  product: wizard.product,
});

const enhance = compose(
  translate(),
  connect(mapStateToProps, { getProductDetail })
);

export default enhance(ModalProductConfirm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalProductConfirm.js